import { ButtonEvent, ButtonType, EventCategory } from '@lendi/analytics-web';

import { lendiAnalytics } from './analytics';
import { eventTracking } from './base';

// Button event
const BUTTON_CLICK = 'Button Clicked';
function baseButtonEventTracking(
  buttonType: ButtonType,
  analytics: ReturnType<typeof lendiAnalytics>,
  props: Pick<ButtonEvent, 'text' | 'position'> & {
    purpose?: string;
    category?: EventCategory;
  }
) {
  eventTracking<ButtonEvent>(analytics, {
    category: EventCategory.FUNNELS,
    event_name: BUTTON_CLICK,
    buttonType,
    ...props,
  });
}

export const buttonEventTracking = (analytics: ReturnType<typeof lendiAnalytics>) => ({
  primary: baseButtonEventTracking.bind(null, ButtonType.PRIMARY).bind(null, analytics),
  secondary: baseButtonEventTracking.bind(null, ButtonType.SECONDARY).bind(null, analytics),
  emphasis: baseButtonEventTracking.bind(null, ButtonType.EMPHASIS).bind(null, analytics),
  empty: baseButtonEventTracking.bind(null, ButtonType.EMPTY).bind(null, analytics),
  link: baseButtonEventTracking.bind(null, ButtonType.LINK).bind(null, analytics),
  icon: baseButtonEventTracking.bind(null, ButtonType.ICON).bind(null, analytics),
});
